import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { payload: Object }

  connect() {
    if (this.hasPayloadValue) this.push(this.payloadValue)
  }

  click() {
    if (this.hasPayloadValue) this.push(this.payloadValue)
  }

  push(payload) {
    window.dataLayer = window.dataLayer || []
    if (payload.ecommerce) window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push(payload)
  }
}
